import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid, TextField, Button } from '@material-ui/core';
import { basicDetailsImageUploadStyle } from './style/BasicDetailsImageUploadStyle';

class BasicDetailsImageUpload extends Component {

    state = {
        minisiteLogo: null
    };

    componentWillReceiveProps(nextProps) {
        this.setState({ minisiteLogo: nextProps.minisiteLogo});
    }

    onChange = (e) => {

        this.setState ({
            minisiteLogo: e.target.files[0]
        }, function() {
            this.props.onAttributeUpdate({ minisiteLogo: this.state.minisiteLogo });
        });

    };

    render() {
        const {classes} = this.props;
        return (
            <Grid container spacing={1}>
                <Grid item sm={8}>
                    <TextField
                        label="LOGO"
                        id="logo"
                        className={classes.textFieldUpload}
                        placeholder="Choose an image for the logo of your site"
                        fullWidth
                        margin="normal"
                        value={this.state.minisiteLogo ? this.state.minisiteLogo.name : ""}
                        onChange={this.onChange}
                        InputLabelProps={{
                            shrink: true,
                            readOnly: true
                        }}
                    />
                    <input 
                        type="file"
                        label="Choose your logo"
                        id="imageupload"
                        placeholder="Choose your logo"
                        accept="image/*"
                        margin="normal"
                        className={classes.upload} 
                        onChange={this.onChange}
                        inputprops={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item sm={4}>
                    <label htmlFor="imageupload" className={classes.labelButton}>
                        <Button 
                            fullWidth
                            variant="contained" 
                            color="default" 
                            component="span">
                            Upload
                        </Button>
                    </label>
                </Grid>
            </Grid>
        )
    }
};

BasicDetailsImageUpload.propTypes = {classes: PropTypes.object.isRequired};

export default (withStyles(basicDetailsImageUploadStyle)(BasicDetailsImageUpload));